import React from "react";
import MuiToggleButtonGroup from "@mui/material/ToggleButtonGroup";

// Formik `component` adapter for MUI ToggleButtonGroup (replaces formik-material-ui-lab).
export default function ToggleButtonGroup({ field, form, meta, value, onChange, ...rest }) {
  const handleChange = (event, newValue) => {
    form.setFieldValue(field.name, newValue);
    if (onChange) onChange(event, newValue);
  };
  return <MuiToggleButtonGroup {...rest} value={value !== undefined ? value : field.value} onChange={handleChange} />;
}
